import { render, staticRenderFns } from "./BuyFormCertificate.vue?vue&type=template&id=3680d356&lang=pug&"
import script from "./BuyFormCertificate.vue?vue&type=script&lang=js&"
export * from "./BuyFormCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports